export class QueryTestRequest {
    public database: string;
    public query: string;
}